import React, { useEffect, useState } from "react";
import Button from "../modules/Button";
import edit from "../../Assets/svg/edit-icon.svg";
import StaticItem from "../modules/StaticItem";
import photo from "../../Assets/svg/photo.svg";
import AddressColumn from "./AddressColumn";
import { useDispatch, useSelector } from "react-redux";
import ErrorBoundary from "../modules/ERcomponent";
import { useNavigate } from "react-router-dom";
import { addTokenInfo, doLogout } from "../LoginPage/redux/actions";
import { addAllIncomeInfo, resetIncome } from "../IncomeDetails/redux/actions";
import { addAllEduInfo, resetEdu } from "../Education/redux/actions";
import {
  addAllPersonalInfo,
  addPersonalInfo,
  resetState,
} from "../PersonalInfo/redux/actions";
import { api } from "../../Services";
import ModalComponent from "../modules/Modal";
import GradientLoader from "../modules/Loader";
import { resetRegister } from "../Register/redux/actions";
import { resetApp } from "../ApplicationForm/redux/actions";
import { resetQueries } from "../Queries/redux/actions";
import { resetStatus } from "../WelcomeBack/redux/actions";
import { clearDisburse } from "../DisburseForm/redux/actions";
import { resetClear } from "../Connect/redux/actions";

function PersonalColumn() {
  const navigate = useNavigate();
  const personalInfo = useSelector((state) => state.personal.personalInfo);
  const idInfo = useSelector((state) => state.tokens.tokens);
  const incomeInfo = useSelector((state) => state.income.incomeInfo);
  const tokenData = useSelector((state) => state.tokens.tokens);
  const education = useSelector((state) => state.education.eduInfo);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const [Link, setLink] = useState("");
  const docs = useSelector((state) => state.tokens.tokens.docs);

  const btnText = () => {
    return (
      <div className="btn-text">
        <span>Personal Details</span>
        <img src={edit} alt="download" />
      </div>
    );
  };
  const navigatePage = () => {
    submitData();
    let baseUrl = window.location.href.split("application/")[0];

    console.log(window.location.href.split("application/"));
    // window.location.replace(baseUrl +"application/form/");
    navigate("/application/form/");
  };
  const getValidDate = (date) => {
    if (!date.split("-")[1]) {
      date = `${date}`;
    } else if (date?.split("-")[0]?.length > 2) {
      date = date.split("-").reverse().join("-");
    }
    return date;
  };
  const CombineData = () => {
    let data = { userId: idInfo.userId };
    let personalInfo2 = {
      ...personalInfo,
      currentAddressProof: "",
      BirthCertificate: "",
      photo: null,
      disability: [],
      personDisability: `[${personalInfo.disability}]`,
      orphan: personalInfo.orphan || "No",
    };
    let eduInfo2 = {
      ...education,
      // admissionLetter: "",
      // paymentReciept: "",
      // year: "2024-2026",
    };
    function filterAndRemove(obj) {
      for (let i in obj.membersList) {
        obj.membersList[i].doc = "";
        // obj.membersList[i].lastName = "";
      }

      return obj;
    }
    let incomeInfo2 = { ...filterAndRemove(incomeInfo) };
    let noMemeber = false;
    let memberArray = [
      "mother",
      "father",
      "sibling1",
      "sibling2",
      "sibling3",
      "guardian",
      "myself",
    ];
    for (let i = 0; i < incomeInfo2.membersList.length; i++) {
      if (
        memberArray.includes(
          incomeInfo2.membersList[i]["relationShipType"].toLowerCase()
        )
      ) {
        noMemeber = true;
        break;
      }
    }
    // let isNone=incomeInfo2.membersList.filter((a) => a["relationShipType"].toLowerCase().includes('mother'|| 'father'|| 'sibling1'||'sibling2'||"guardian"||'myself'))
    incomeInfo2 = { ...incomeInfo2, earningMember: noMemeber };
    data = {
      ...data,
      application: { id: idInfo.appId, applicationStatus: "Registered" },
    };
    data = {
      ...data,
      application: { ...data.application, personalInfo: { ...personalInfo2 } },
    };
    data = {
      ...data,
      application: {
        ...data.application,
        incomeInfo: { ...incomeInfo2 },
      },
    };
    data = {
      ...data,
      application: {
        ...data.application,
        eduInfo: {
          ...eduInfo2,
          year: ["B.Tech", "B.E."].includes(tokenData?.registrationData?.degree)
            ? "2024-2028"
            : "2024-2026",
        },
      },
      registration: { ...tokenData.registrationData },
      salesForceUserId: tokenData.salesForceUserId,
    };
    return data;
  };
  const destructureData = (data) => {
    if (data?.user) {
      data = data.user;
    }
    dispatch(addTokenInfo(["userId", data?.userId]));
    dispatch(addTokenInfo(["appId", data?.application?.id]));
    dispatch(addTokenInfo(["personalId", data?.application?.personalInfo?.id]));
    dispatch(addTokenInfo(["registrationData", data?.registration]));
    dispatch(addTokenInfo(["applicationData", data?.application]));
    dispatch(addTokenInfo(["salesforceUserId", data?.salesforceUserId]));
    dispatch(
      addTokenInfo(["applicationStatus", data?.application?.applicationStatus])
    );
    if (data?.application?.incomeInfo) {
      dispatch(addAllIncomeInfo(data?.application?.incomeInfo));
    }
    dispatch(addAllEduInfo(data?.application?.eduInfo));

    let personalInfo = data?.application?.personalInfo;
    personalInfo["BirthCertificate"] = "";
    dispatch(addAllPersonalInfo(personalInfo));
    let disList = [];
    if (data?.application?.personalInfo?.personDisability) {
      const disabilities = data.application.personalInfo.personDisability;
      // disList = disabilities.replace(/^\[|\]$/g, "").split(",");
      disList = disabilities
        .split(",")
        // .map(item => item.trim()) // Remove whitespace around elements
        .filter((item) => item && item !== "[" && item !== "]" && item !== "");
      disList = disList?.map((item) => item.replace(/^\[|\]$/g, ""));
    }
    if (disList.length === 0 || disList.includes(null)) {
      disList = [];
    }
    dispatch(addPersonalInfo({ type: "disability", value: disList }));

    /*    let url = GetBaseUrl(window.location.href);
    if (data.user.application.applicationStatus === "Submitted") {
      navigate("/application/submitted-status");
    } else {
      navigate("/application");
    }*/
  };
  const getLogout = async () => {
    // const personalInfo = useSelector((state) => state.personal.personalInfo);
    // const dispatch = useDispatch();
    // const tokenData = useSelector((state) => state.tokens.tokens);

    try {
      let users = await api.logout(tokenData.token, personalInfo?.mobile);
      console.log("logout api", users);
      // if (users.statusCode == 200) {
      dispatch(resetState());
      dispatch(resetIncome());
      dispatch(resetEdu());
      dispatch(resetRegister());
      dispatch(resetApp());
      dispatch(resetQueries());
      dispatch(resetStatus());
      dispatch(clearDisburse());
      dispatch(resetClear());
      dispatch(doLogout());
      // }
      // return users;
    } catch (error) {
      console.error("Error logging out:", error);

      //   } finally {
      // setIsLoading(false);
    }
  };
  const logoutMsg = async () => {
    let users = await getLogout();
    console.log("logout api", users);
    console.log("u have been logged out");
  };
  const submitData = async () => {
    try {
      let users;
      setLoading(true);
      users = await api.update(CombineData(), tokenData.token);
      // return users;
      if (users?.statusCode == 200) {
        setLoading(false);

        destructureData(users.data);
      } else if (users.data.includes("Session expired")) {
        logoutMsg();
      }
    } catch (error) {
      setLoading(false);

      console.error("Error invoking Aadhaar OTP:", error);
      // Handle error scenario
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    let currentUrl = window.location.href;
    const cleanedUrl = currentUrl.replace(/^https?:\/\/(www\.)?/, "");
    console.log("cleaned url", cleanedUrl);
    setLink(cleanedUrl);
    // checkLogin()
  }, []);
  console.log("personalInfo", personalInfo);
  return (
    <div className="personal-col review-col">
      {Link.split("/")[2] === "app-preview" ? (
        <div className="preview-title set-title"> Personal Details</div>
      ) : (
        <Button
          type={"outlined"}
          onClickHandler={() => navigatePage()}
          value={btnText()}
        />
      )}
      {/* </div> */}
      <div className="col">
        <div className="left-col">
          <div className="set-title">Basic Details</div>
          <StaticItem title={"First Name"} value={personalInfo?.firstName} />
          {/* <StaticItem title={"Last Name"} value={personalInfo?.lastName} /> */}
          <StaticItem title={"Gender"} value={personalInfo?.gender} />
          <StaticItem
            title={"Date of Birth"}
            value={getValidDate(personalInfo?.dob)}
          />
          <StaticItem
            title={"Mobile Number"}
            mask={true}
            value={personalInfo?.mobile}
          />
          <StaticItem
            title={"Email Address"}
            mask={true}
            value={personalInfo?.email || "personalInfo?.email"}
          />
          <StaticItem
            title={"Disability"}
            value={personalInfo?.disability?.join(", ")}
          />
          <StaticItem title={"Orphan"} value={personalInfo?.orphan ?? ""} />
        </div>
        <div className="right-col">
          <div className="col-item">
            <div className="set-title">Photograph</div>
            {/* {personalInfo?.photo && */}
            <ErrorBoundary>
              {tokenData?.docs?.profilePicture?.fileBlob && (
                <div className="image">
                  <img
                    className="image"
                    src={
                      docs?.profilePicture?.fileBlob
                        ? "data:image/" +
                          docs?.profilePicture?.fileType +
                          ";base64," +
                          docs?.profilePicture?.fileBlob
                        : personalInfo?.photo
                    }
                    alt="Preview"
                    style={{ maxWidth: "100%", height: "100%" }}
                  />
                </div>
              )}
            </ErrorBoundary>
            {/* } */}
          </div>
          {/* {docs?.BirthCertificate && ( */}
          <div className="col-item">
            <div className="doc-col">
              <div className="doc-item">
                {/* <div className="set-title">Birth Certificate</div> */}
                {/* {personalInfo?.photo && */}
                <ErrorBoundary>
                  {/* {docs?.BirthCertificate && ( */}
                  <StaticItem
                    type={"doc"}
                    title={"Birth Certificate"}
                    // value={item?.doc?.name || ''}
                    doc={docs?.BirthCertificate}
                    docUrl={docs?.BirthCertificate?.documentUrl}
                    value={docs?.BirthCertificate?.name}
                    size={Math.floor(docs?.BirthCertificate?.size / 1024)}
                  />
                  {/* // )} */}
                </ErrorBoundary>
              </div>
            </div>
            {/* } */}
          </div>
          {/* // )} */}
          <div className="col-item">
            <div className="set-title">Work Experience</div>

            <StaticItem title={""} value={personalInfo?.experience} />
          </div>
        </div>
      </div>
      <AddressColumn />
      {loading && (
        <ModalComponent
          className={"loader-model"}
          show={loading}
          // handleClose={() => CancelData()}
          // title={ModalData.title}
          // content={ModalData.desc}
        >
          <GradientLoader />
        </ModalComponent>
      )}
    </div>
  );
}

export default PersonalColumn;
